import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { CONTACT } from "../../content/catalog";

export default function SiteFooter() {
  const { t } = useTranslation();
  return (
    <footer className="site-footer">
      <div className="footer-row">
        <span>{t("footer.copy")}</span>
        <span className="footer-links">
          <Link to="/gizlilik-politikasi">{t("footer.privacy")}</Link>
          {" · "}
          <Link to="/iptal-iade-sartlari">{t("footer.cancel")}</Link>
        </span>
      </div>
      <div className="footer-extra">
        <span>
          <a href={CONTACT.instagram} target="_blank" rel="noopener noreferrer">Instagram</a>
          {" · "}
          <a href={CONTACT.youtube} target="_blank" rel="noopener noreferrer">YouTube</a>
        </span>
      </div>
    </footer>
  );
}
